var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-message-template-components-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.$t("auto.whatsappBusinessApiV2MessageTemplateComponentsUpdated")
          )
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.event")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.templateName")))]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_name"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.templateId")))]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_id"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.language")))]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(_vm.activity, "payload.message_template_language")
              )
          ),
        ]),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_title")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.title")))]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(_vm.activity, "payload.message_template_title")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_element")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.content")))]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(_vm.activity, "payload.message_template_element")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_footer")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.footer")))]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(_vm.activity, "payload.message_template_footer")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.templateButtons.length > 0
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.buttons")))]),
              _vm._v(":\n            "),
              _c(
                "ul",
                { staticClass: "buttons-list" },
                _vm._l(_vm.templateButtons, function (btn, idx) {
                  return _c("li", { key: idx }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(btn.message_template_button_text) +
                        " (" +
                        _vm._s(btn.message_template_button_type) +
                        ")\n                "
                    ),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }